/**
 * Dashboard Redux Slice
 * - Manages dashboard statistics and data
 * - Handles loading states for dashboard widgets
 * - Stores recent users, pet finders, and stats
 */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchDashboardAPI } from "../../services/dashboardAPI";

// ✅ Fetch dashboard data
export const fetchDashboardData = createAsyncThunk(
  "dashboard/fetchDashboardData",
  async () => {
    const response = await fetchDashboardAPI();
    return response.data;
  }
);

const initialState = {
  data: {
    active_vets: {
      total: 0,
      this_month: 0,
      last_week: 0
    },
    bookings: {
      today: 0,
      this_month: 0,
      last_week: 0
    },
    new_users: {
      last_7_days: 0,
      this_month: 0,
      last_week: 0
    },
    recent_users: [],
    recent_pet_finder_data: []
  },
  status: "idle",
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default dashboardSlice.reducer;
